import { deriveMaterial } from 'Pods/ThreeDStudio/Shared/Utils/deriveMaterial'
import { getAssetByTypeAndSource } from 'Pods/ThreeDStudio/Shared/Utils/getAssetByTypeAndSource'
import { getInputImageAsset } from 'Pods/ThreeDStudio/Shared/Utils/getInputImageAsset'
import {
  ACTION,
  DEFAULT_TEXTURE_SETTINGS,
  PROVIDER,
  TEXTURE_ACTION_TAB,
  VIEWER_SIDEBAR_TAB,
} from 'Pods/ThreeDStudio/Store/constants'

import { getModelFormatOutput } from './getModelFormatOutput'
import { normalizeRunAttributes } from './normalizeRunAttributes'

/**
 * Builds the ThreeDStudio store patch for a Tripo3D retexture-default run.
 * Mirrors parseTencentRetextureProData but derives material directly from
 * enablePbr (Tripo3D retexture only exposes a PBR toggle on the FE form).
 *
 * @param {Object} openedModel - Run object from the library
 * @returns {Object} parsedData - ThreeDStudio store patch
 */
export const parseTripo3dRetextureDefaultData = (openedModel) => {
  const {
    prompt,
    enablePbr,
    modelFormatOutput: rawModelFormatOutput,
    inputAssets,
    outputAssets,
    generatorSessionId,
    id: sessionId,
  } = openedModel
  const enhancedProvider = PROVIDER.TRIPO3D
  const enhancedAction = ACTION.RETEXTURE
  const activeTextureActionTab = prompt ? TEXTURE_ACTION_TAB.TEXT : TEXTURE_ACTION_TAB.IMAGE
  const material = deriveMaterial(enablePbr, false)
  const { textureQuality } = normalizeRunAttributes(openedModel.providerRunAttributes)

  const {
    assetId: inputThreeD,
    fileUrl: inputThreeDUrl,
  } = getAssetByTypeAndSource(outputAssets, '3d_model', 'ai_generated')
  const modelFormatOutput = getModelFormatOutput({
    modelFormatOutput: rawModelFormatOutput,
    modelUrl: inputThreeDUrl,
  })
  const {
    assetId: inputImage,
    fileUrl: inputImageUrl,
  } = getInputImageAsset(inputAssets)

  const schema = { enhancedAction, enhancedProvider }
  const generation = { sessionId, generatorSessionId }
  const viewer = { fileFormat: modelFormatOutput, inputThreeD, material }
  const textureSettings = {
    inputImage,
    inputImageUrl,
    prompt,
    material,
    enablePbr,
    // Runs persisted before texture_quality existed reopen with no value; the schema/server
    // default is 2k, so fall back to it instead of leaving the new selector with no active button.
    textureQuality: textureQuality ?? DEFAULT_TEXTURE_SETTINGS.textureQuality,
  }

  const ui = {
    isModelSettingsOpen: false,
    isViewerSidebarOpen: true,
    activeViewerSidebarTab: VIEWER_SIDEBAR_TAB.TEXTURE,
    activeTextureActionTab,
  }

  return {
    openedModel,
    schema,
    textureSettings,
    ui,
    generation,
    viewer,
  }
}
